import { Component, OnDestroy, OnInit } from '@angular/core';
import { ProductSearchPage, ProductSearchService, TranslatePipe } from '@spartacus/core';
import { PageLayoutService, ProductListComponentService, ViewConfig, ViewModes, PaginationComponent } from '@spartacus/storefront';
import { Observable, Subscription } from 'rxjs';
import { tap } from 'rxjs/operators';
import { KnBrCustomerContextService } from 'src/app/store/kn-br-customer-context/kn-br-customer-context.service';
import { ProductViewModeService } from './../../services/product-view-mode-service';
import { KnBrCommonService } from 'src/app/services/kn-br-common.service';
import { Router } from '@angular/router';
import { KnBrProductGridItemComponent } from './kn-br-product-grid-item/kn-br-product-grid-item.component';
import { KnBrProductListItemComponent } from './kn-br-product-list-item/kn-br-product-list-item.component';
import { KnBrProductScrollComponent } from './kn-br-product-scroll/kn-br-product-scroll.component';
import { AsyncPipe } from '@angular/common';

@Component({
    selector: 'kn-br-product-list',
    templateUrl: './kn-br-product-list.component.html',
    styleUrls: ['./kn-br-product-list.component.scss'],
    imports: [PaginationComponent, KnBrProductGridItemComponent, KnBrProductListItemComponent, KnBrProductScrollComponent, AsyncPipe, TranslatePipe]
})
export class KnBrProductListComponent implements OnInit, OnDestroy {
  private subscription = new Subscription();
  isInfiniteScroll: boolean;
  model$: Observable<ProductSearchPage> = this.productListComponentService.model$;
  viewMode$ = this.viewModeService.getViewMode$();
  ViewModes = ViewModes;
  customerContext: string;
  spinner$ = this.knBrCommonService.loadSpinner$();
  constructor(
    protected pageLayoutService: PageLayoutService,
    protected productListComponentService: ProductListComponentService,
    public scrollConfig: ViewConfig,
    protected viewModeService: ProductViewModeService,
    protected productSearchService: ProductSearchService,
    protected knBrCustomerContextService: KnBrCustomerContextService,
    private knBrCommonService: KnBrCommonService,
    protected router: Router
  ) {
    if(router.url.includes('/search/'))
    this.knBrCommonService.setSpinner(true);
  }
  ngOnInit(): void {
    this.isInfiniteScroll = this.scrollConfig.view.infiniteScroll.active;
    // this.isInfiniteScroll = true;
    this.viewModeService.setViewMode(ViewModes.Grid);
    this.model$.subscribe(() => this.knBrCommonService.setSpinner(false));
    this.subscription.add(
      this.knBrCustomerContextService.getActiveCustomerNumber().subscribe((response) => {
        this.customerContext = response ? response : null;
      })
    );
  }
  ngOnDestroy(): void {
    this.productSearchService.getResults();
    this.productSearchService.clearResults();
    this.subscription.unsubscribe();
  }

}
